import EntityLogo from 'components/EntityLogo';
import HmsEntityTableController from 'components/HmsEntityTableController';
import useEntities from 'hooks/useEntities';

const AwardsPlayer = () => {
  const entities = useEntities();

  // No filterGroups for now, but could be added for e.g. season, type, etc.
  const showColumns = [
    'NameWithLogo', 
    'nick', 
    'short', 
    'description', 
    'foundDate', 
    'type',
  ];

  return (
    <HmsEntityTableController
      entity={entities.Award}
      exportEnabled={false}
      columnSelectorEnabled={false}
      filterEnabled={false}
      showColumns={showColumns}
      renderMobileRow={(record) => (
        <div>
          <div className="border-b-[1px] border-gray-100 px-4 py-4 flex rounded-t-md" style={{ background: 'linear-gradient(90deg, #f2f2f2 0%, #fafafa 2%, #fafafa 98%, #f2f2f2 100%)' }}>
            <div className="flex flex-col gap-[1px]">
              <span className="flex items-center gap-3">
                <EntityLogo entity={record} size={24} />
                <span className="font-bold text-[0.9rem]">{record?.name}</span>
              </span>
              {/* <span className="text-gray-400 text-[0.8rem]">{record?.competition}</span> */}
            </div>
            {/* <div className="ml-auto my-auto flex items-center gap-1">
              <HmsStatusTag className="m-0" status={record.status} entity="Award" />
            </div> */}
          </div>
          <div className="px-6 py-4 flex items-center rounded-b-md" style={{ background: 'linear-gradient(90deg, #f8f8f8 0%, #fff 2%, #fff 98%, #f8f8f8 100%)' }}>
            <div className="w-full grid grid-cols-4 gap-y-2">
              <span className="text-gray-500">Nick:</span>
              <span className="col-span-3">{record?.nick}</span>
              <span className="text-gray-500">Short:</span>
              <span className="col-span-3">{record?.short}</span>
              <span className="text-gray-500">Description:</span>
              <span className="col-span-3">{record?.description}</span>
              <span className="text-gray-500">Found Date:</span>
              <span className="col-span-3">{record?.foundDate}</span>
              <span className="text-gray-500">Type:</span>
              <span className="col-span-3">{record?.type}</span>
            </div>
          </div>
        </div>
      )}
      canCreate={false}
      onRowClickLink={() => null}
    />
  )
}

export default AwardsPlayer 